export const roles = Object.freeze({
  master: 1,
  admin: 2,
  support: 3,
  owner: 4,
  manager: 5,
  cashier: 6,
  accountant: 7,
});
